/*
 * common / filter
 */
export function initFilter() {

    
    // フィルターボタンクリック時の動作
    $('.s-filter_btn_wrap').on('click', function (event) {
        let $thisBtn = $(this).find('.s-filter_btn');
        let $this = $(this);

        if ($(event.target).closest('.s-filter_clearBtn').length) {
            event.stopPropagation();
            return;
        }

        // フィルターボタンをクリックしたときフォーカスをメニューに移す
        if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {

            $('.s-filter_btn_wrap').not($this).removeClass('is-on');
            $('.s-filter_btn').not($thisBtn).attr('aria-expanded', false);
            $('.s-filter_btn_wrap').not($this).siblings('.s-filter_menu_box').removeClass('is-show');

            if ($this.hasClass('is-on')) {
                $this.removeClass('is-on');
                $thisBtn.attr('aria-expanded', false);
                $this.siblings('.s-filter_menu_box').removeClass('is-show');
            } else {
                $this.addClass('is-on');
                $thisBtn.attr('aria-expanded', true);
                $this.siblings('.s-filter_menu_box').addClass('is-show');

                setTimeout(function () {
                    $this.siblings('.s-filter_menu_box').find('.s-filter_menu').focus();
                }, 100);
            }
        }

        // 画面縦幅が小さい＆メインのコンテンツが短いときの対応
        const winHeight = $(window).outerHeight();
        let $filterInner = $this.siblings('.s-filter_menu_box').find('.s-filter_menu_inner');
        if ($filterInner.length === 0) {
            // 要素が存在しない場合は以降の処理をスキップ
            return;
        }
        let filterTop = $filterInner.offset().top;

        if (200 > winHeight - filterTop - 10) {
            $filterInner.css({
                'max-height': 'none',
            });
        } else {
            $filterInner.css({
                'max-height': winHeight - filterTop - 10
            });
        }

        // 画面横幅が短いときの対応
        let winWidth = $(window).width();
        let btnLeft = $this.offset().left;
        let btnRight = winWidth - (btnLeft + $this.outerWidth());
        let $tarFilter = $this.siblings('.s-filter_menu_box').find('.s-filter_menu');
        let filterWidth = $tarFilter.outerWidth();
        let lossRightWidth = filterWidth - (winWidth - btnLeft) + 16;
        let lossLeftWidth = filterWidth - (winWidth - btnRight) + 16;
        let $tarFilterBottom = $tarFilter.find('.s-filter_footer');

        if (lossRightWidth > 0) {
            // フィルターが左右どちらに寄せてもはみ出してしまう場合
            if (lossLeftWidth > 0) {
                $tarFilter.css({
                    'width': winWidth - 60,
                    'left': - (btnLeft - 30)
                });
                $tarFilterBottom.css({
                    'flex-direction': 'column',
                    'gap': '20px',
                    'align-items': 'center'
                });

                // フィルターが右にはみ出す場合
            } else {
                $tarFilter.css({
                    'right': 0,
                    'left': 'auto'
                });
            }
        }

    });

    // フィルター以外の部分クリックで閉じる
    $(document).on('keydown mousedown', function (event) {
        if ($('.s-filter_btn_wrap').hasClass('is-on')) {

            if ($(event.target).closest('.s-filter_menu').length || $(event.target).closest('.s-filter_btn_wrap').length) {
                event.stopPropagation();
                return;
            }

            $('.s-filter_btn_wrap').removeClass('is-on');
            $('.s-filter_btn').attr('aria-expanded', false);
            $('.s-filter_menu_box').removeClass('is-show');

            if (!$(event.target).hasClass('s-headerModal')) {

                $('.s-main').css({
                    'margin-bottom': 0
                });
            }
        }

    });

    // 絞り込みをしたときにプルダウンを閉じる
    $('.s-filter_select, .s-search_btn').on('click', function () {
        $(this).closest('.s-filter_menu_box').siblings('.s-filter_btn_wrap').removeClass('is-on').attr('aria-expanded', false);
        $(this).closest('.s-filter_menu_box').removeClass('is-show');
    });

    // クリアボタン動作
    $('.s-filter_clear').on('click', function () {
        let $checkBox = $(this).closest('.s-filter_menu').find('.s-checkbox');
        $checkBox.each(function () {
            $(this).prop('checked', false);
        });
    });

    // 選択後バツボタン動作
    $('.s-filter_clearBtn').on('click', function () {
        $(this).closest('.s-filter_btn_wrap').removeClass('is-active');
        $(this).addClass('is-hide');
    });
}